import { Pipe, PipeTransform } from '@angular/core';
import { Facet } from '@models/api-search.models';

/**
 * Get total amount of active facets in a group
 */
@Pipe({
    name: 'activeFacetsCount',
    standalone: true
})
export class ActiveFacetsCountPipe implements PipeTransform {
    transform(facets?: Facet[]): string | null {
        if (!facets?.length) {
            return null;
        }

        const count = facets.reduce((prev: number, curr: Facet) => (curr.selected ? prev + 1 : prev), 0);

        if (count) {
            return count.toString();
        }

        return null;
    }
}
